import { StatusService } from "external-services/status-service";
const NS = 'UniqueStatus'; // jshint ignore:line

export default function UniqueStatus() { // as UniqueStatus
    "ngInject";
    console.log("Unique Status Loading");
    return {
        require: 'ngModel',
        link,
        restrict: 'A',
        scope: {
            statusName: "=",
            statusId: "="
        }
    };

    function link(scope, element, attrs, ngModel) {

        var validate = function (viewValue) {
            console.log("UniqueStatus Validating");
            let statuses = JSON.parse(attrs.uniqueStatus);
            console.log(scope.statusName);
            if (!statuses) {
                return;
            }

            //At least one of these has to be set by an attribute
            const status = {
                code: viewValue,
                name: scope.statusName ?? viewValue,
                _id: scope.statusId,
            }

            ngModel.$setValidity('uniqueStatus', !StatusService.checkIfStatusExists(status, statuses));

            return viewValue;
        }

        ngModel.$parsers.unshift(validate);
        ngModel.$formatters.push(validate);

        attrs.$observe('uniqueStatus', function () {
            // Whenever the comparison model changes we'll re-validate
            return validate(ngModel.$viewValue);
        });

        scope.$watch('statusName', function (newValue, oldValue) {
            if (newValue){
                validate(ngModel.$viewValue);
            }
        });
    }
}
